"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Typography_1 = require("src/components/Typography/Typography");
var makeInput_1 = __importDefault(require("./makeInput"));
var StyledTextInput_1 = require("./StyledTextInput");
var Input = (0, makeInput_1.default)((0, Typography_1.makeText)('input'));
var TextInput = function (_a) {
    var icon = _a.icon, reverse = _a.reverse, margin = _a.margin, label = _a.label, message = _a.message, rest = __rest(_a, ["icon", "reverse", "margin", "label", "message"]);
    return (react_1.default.createElement(StyledTextInput_1.StyledTextInputContainer, { margin: margin },
        label && react_1.default.createElement(StyledTextInput_1.StyledLabel, null, label),
        react_1.default.createElement(Input, __assign({ icon: icon, reverse: reverse }, rest, { messageType: message ? message.type : null })),
        icon && react_1.default.createElement(StyledTextInput_1.StyledIcon, { role: "img", reverse: reverse }, icon),
        message && react_1.default.createElement(StyledTextInput_1.StyledMessage, { messageType: message.type }, message.text)));
};
exports.default = TextInput;
